<template>
  <div class="feedback-banner">
    <v-row no-gutters>
      <v-col cols="12" md="8" class="feedback-left">
        <span class="feedback-label">Ihre Meinung zählt</span>
        <h2 class="feedback-heading">Gestalten Sie die nächste BAHN 1 mit!</h2>
        <p class="feedback-text">
          Was hat Ihnen gefallen, was hat gefehlt? Und vor welchen
          Herausforderungen stehen Sie?
        </p>
      </v-col>
      <v-col cols="12" md="4" class="feedback-right">
        <v-btn class="feedback-button">Feedback geben</v-btn>
        <span class="feedback-duration">Dauer: ca. 4 Min</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Bahn1FeedbackBanner"
};
</script>

<style scoped>
.feedback-banner {
  width: 100%;
  min-height: 130px;
  padding: 16px 24px;
  background: #008cc8;
  color: #ffffff;
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.feedback-left {
  padding: 0 16px;
  text-align: left;
}
.feedback-label {
  font-family: "GeometriaLight";
  font-size: 12px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin-top: 26px auto 8px;
}
.feedback-heading {
  margin-bottom: 16px;
  font-family: "GeometriaGeometria";
  font-size: 30px;
  letter-spacing: 0.6px;
}
.feedback-text {
  margin-bottom: 24px;
  font-family: "GeometriaLight";
  font-size: 16px;
  line-height: 1.4;
  letter-spacing: 0.32px;
}
.feedback-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
}
.feedback-button {
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 3px;
  font-family: "GeometriaMedium";
  box-shadow: none;
  color: #004ba0;
  padding: 12px 32px;
}
.feedback-duration {
  margin-top: 8px;
  font-size: 12px;
  letter-spacing: 0.6px;
  color: #ffffff;
}
</style>
